import videojs from 'video.js';
import 'videojs-youtube/dist/Youtube';
import Swiper from 'swiper';

const rootName = 'base-slider';

function init(el) {
  const slides = el.querySelectorAll('.swiper-slide');

  if (el.querySelectorAll('.swiper-slide').length > 1) {
    const elChild = document.createElement('div');
    elChild.classList.add('swiper-pagination');
    el.appendChild(elChild);

    el.swiper = new Swiper(el, {
      loop: true,
      slidesPerView: 1,
      speed: 1000,
      pagination: '.swiper-pagination',
      autoplay: el.getAttribute('data-duration'),
      paginationClickable: true,
      keyboardControl: true,
    });
  }

  // all slides including duplicates and not swiper
  [].forEach.call((el.swiper && el.swiper.slides) || slides, (slide) => {
    const slideVideo = slide.querySelector('video');
    videojs(slideVideo, {
      controls: true,
      loop: true,
      autoplay: false,
      loadingSpinner: false,
      preload: 'auto',
      techOrder: ['youtube'],
      sources: [
        {
          type: 'video/youtube',
          src: slideVideo.getAttribute('src'),
        },
      ],
    });
  });
}

export default (() => {
  const rootEl = document.querySelectorAll(`.${rootName}`);
  [].forEach.call(rootEl, (el) => {
    init(el);
  });
})();



// WEBPACK FOOTER //
// ./src/js/base-slider.js